/* eslint-disable no-restricted-syntax */
export default () => {
  const offices = document.querySelectorAll('#js-offices .js-office');
  const maps = document.querySelectorAll('#js-offices .js-map');

  if (!offices.length) {
    return false;
  }

  for (const office of offices) {
    office.addEventListener('click', (e) => {
      const targetOffice = e.currentTarget;
      const targetMapId = targetOffice.dataset.id;

      for (const o of offices) {
        o.classList.remove('lg:bg-gray-30');
        o.classList.add('lg:bg-white');
      }

      for (const map of maps) {
        map.classList.add('hidden');

        if (map.dataset.id === targetMapId) {
          map.classList.remove('hidden');
        }
      }

      targetOffice.classList.remove('lg:bg-white');
      targetOffice.classList.add('lg:bg-gray-30');
    });
  }
};
